
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["cog-icon cog-i-next",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","focusable":"false","class":"cog-icon cog-i-next"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('g',{staticClass:"cog-i-chevron"},[_c('path',{attrs:{"stroke-linecap":"square","d":"M6.58 14.42L12 9 6.59 3.59"}})])])])
          )
        }
      }
    